import React from "react";
import { useEffect,useContext,useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../GlobalContext';
import { methods } from '../../Validation';
import axios from 'axios';



    

const Body = () => {
   const { t, i18n } = useTranslation();
   const loader = document.getElementById("loder-tive");
      const { default_country_detail } = useContext(GlobalContext);
           const { default_langage_details } = useContext(GlobalContext);

       const [showThanks,setSetshowThanks] = useState(true);
    
         let default_country_detail_data = null;
    let default_language_detail_data =null;
  if(localStorage.getItem('defult_country_details') != null){
    default_country_detail_data = JSON.parse(localStorage.getItem('defult_country_details'));
    default_language_detail_data = JSON.parse(localStorage.getItem('defult_language_details'));
  }

     console.log(default_country_detail_data);
       const [formData, setFormData] = useState({
           fromDate: '',
           toDate: '',
            startTime: '',
           endTime: '',
           title: '',
           cost:'',
           address:'',
           countryId:'',
           languageField:default_langage_details.label,
         
           campaignCode:''
   
         });
           const [formdata_valid_error,setFormDatavalid] = useState({//validName
                 fromDate: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('From_date_is_required')}],required:true,error:false,errormsg:null
                 },
                 toDate: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('to_date_is_required')}],required:true,error:false,errormsg:null
                 },
                startTime: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The start Time field is required'}],required:true,error:false,errormsg:null
                                  },
                endTime: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The end Time field is required'}],required:true,error:false,errormsg:null
                                  },
                 title: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('Title_is_required')}],required:true,error:false,errormsg:null},
                 cost:{validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('Cost_is_required')},{keyname:'validnumber',methods:'validnumber',parmeters:[],errormag:t('Please_enter_numbers')}],required:true,error:false,errormsg:null},
                 address:{validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t("Address_is_required")}],required:true,error:false,errormsg:null},
             
                 campaignCode: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:t('Campaign_code_is_required')}],required:true,error:false,errormsg:null},
         
               });
          const [loading, setLoading] = useState(true);
           const [error, setError] = useState(null);
   const [cityoptions, setOptionData] = useState([]);
       const { siteName } = useContext(GlobalContext);
       const { default_country } = useContext(GlobalContext);
       const { default_langage } = useContext(GlobalContext);
       let baseUrl = siteName.baseUrl;
       let defult_endpoint = siteName.training_endpoits;
       let webEndpoints = siteName.commonEndpoints;
        let country_detils =JSON.parse(localStorage.getItem('country_detils'));
   useEffect(() => {
      const fetchCountries = async () => {
        try {
          const response = await fetch(baseUrl + webEndpoints + 'get/all/countries');
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const countries = await response.json();
    
          let cities = '';
         
          countries.map((country) => {
            if(country.countryId == default_country){
              cities = country.cities;
            }
              
          });
          setOptionData(cities);

          setLoading(false);
        } catch (error) {
          setError(error);
          setLoading(false);
        }
      };
    
      fetchCountries();
    }, []);

       const handleChange = (e) => {
            const { name, value } = e.target;
           
            if (name in formdata_valid_error) {
                if('validtion' in formdata_valid_error[name]){
               
                  let result = null;
                  let newformdata;
                    for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                        if (methods[formdata_valid_error[name].validtion[i].methods]) {
                            result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                            }
                       if(result == false){
                        formdata_valid_error[name].error = true;
                        formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                        newformdata = formdata_valid_error[name];
                         setFormDatavalid(prev => ({
                        ...prev,
                        [name]:newformdata
                        }));
                        break;
                       }
                       if(result == true){
                        
                          formdata_valid_error[name].error = false;
                        formdata_valid_error[name].errormsg = null;
                        newformdata = formdata_valid_error[name];
                         setFormDatavalid(prev => ({
                        ...prev,
                        [name]:newformdata
                        }));
                       }
    
                }
                
                }
     
            }
          
            setFormData(prev => ({
              ...prev,
              [name]: value
            }));
            console.log(formData)
          };

               const handleSubmit = (e) => {
                  e.preventDefault(); 
                  let value;
                     loader.classList.remove('d-none');
                  for (const name in formData) {
                      value = formData[name];
                      if (name in formdata_valid_error) {
                      if('validtion' in formdata_valid_error[name]){
                     
                        let result = null;
                        let newformdata;
                          for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                              if (methods[formdata_valid_error[name].validtion[i].methods]) {
                                  result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                                  }
                             if(result == false){
                              formdata_valid_error[name].error = true;
                              formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                              newformdata = formdata_valid_error[name];
                               setFormDatavalid(prev => ({
                              ...prev,
                              [name]:newformdata
                              }));
                              break;
                             }
                             if(result == true){
                              
                                formdata_valid_error[name].error = false;
                              formdata_valid_error[name].errormsg = null;
                              newformdata = formdata_valid_error[name];
                               setFormDatavalid(prev => ({
                              ...prev,
                              [name]:newformdata
                              }));
                             }
          
                      }
                      
                      }
           
                  }
                      }
          
                      let validation = true;
                       for (const key in formdata_valid_error) {
                          if(formdata_valid_error[key].error == true){
                             validation = false; 
                             loader.classList.add('d-none');
                             break;
                          }
                       }
          
                       if(validation){
                                     
                          console.log('Form submitted:', 'success');
                          console.log('Form submitted:', formData);
                          handleSubmit_axios(formData);
                          
                       }else{
                          loader.classList.add('d-none'); 
                          console.log('Form submitted:', 'faild');
                          console.log('Form submitted:', formdata_valid_error);
                       } 
                };

                const handleSubmit_axios = async (formData) => {
      
        try {
      
        //  const response = await axios.post(baseUrl+defult_endpoint+'register/student', formData);
 const token =  localStorage.getItem('token');
          let formdata_submit = formData
                  formdata_submit.cityId = parseInt(formData.cityId);
          formdata_submit.cost = parseInt(formData.cost);

            const response = await axios.post(baseUrl+'web/v1/create/training/session', formdata_submit,{
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
          let data = response;
          console.log(data);

          /*call back data*/
        setFormData({
           fromDate: '',
           toDate: '',
             startTime: '',
           endTime: '',
           title: '',
           cost:'',
           address:'',
           countryId:'',
           languageField:default_langage_details.label,
          
           campaignCode:''
   
         });
      if(data.status){
        loader.classList.add('d-none');
        setSetshowThanks(false);
      }
      //window.location.reload();
         
        } catch (error) {
          //setErrormsg(error.response.data.message);
          console.log(error.response.data);
          /*error call back*/
        //  window.location.reload();
          logout_action();
        }
      
    };
     const { setLogin } = useContext(GlobalContext);
    const logout_action = () => {
      localStorage.removeItem('token');
      localStorage.removeItem('name');
      localStorage.removeItem('loginbefore');
      localStorage.removeItem('role');
      setLogin(false);
      window.location.reload();
    };
   
    
return (
       <section className="cfan-form-section">
        <div class="container">
       {showThanks? <form onSubmit={handleSubmit}>
            <div class="heading-form">
                <h3>{t('Create_Training_Sessions')}</h3>
            </div>
            <div class="form-items-wrapper">
                <div class="form-intem">
                    <label htmlFor="fdate">{t('From_Date')}{formdata_valid_error.fromDate.required? <span>*</span> : ''}</label>
                    <input type="date" onChange={handleChange}  name="fromDate" id="fdate" />
                       {formdata_valid_error.fromDate.error? <div className="error">{formdata_valid_error.fromDate.errormsg}</div> : ''}
                </div>
                <div class="form-intem">
                    <label htmlFor="tdate">{t('To_Date')}{formdata_valid_error.toDate.required? <span>*</span> : ''}</label>
                    <input type="date" onChange={handleChange}  name="toDate" id="tdate" placeholder={t('Form_Date')} />
                     {formdata_valid_error.toDate.error? <div className="error">{formdata_valid_error.toDate.errormsg}</div> : ''}
                </div>
                      <div class="form-intem">
                    <label htmlFor="fdate">{t('Start_Time')}{formdata_valid_error.startTime.required? <span>*</span> : ''}</label>
                    <input type="time" onChange={handleChange}  name="startTime" id="fdate" placeholder={t("Start_Time")} />
                  {formdata_valid_error.startTime.error? <div className="error">{formdata_valid_error.startTime.errormsg}</div> : ''}
                </div>
                   <div class="form-intem">
                    <label htmlFor="fdate">{t('End_Time')}{formdata_valid_error.startTime.required? <span>*</span> : ''}</label>
                    <input type="time" onChange={handleChange}  name="endTime" id="fdate" placeholder={t("End_Time")} />
                  {formdata_valid_error.endTime.error? <div className="error">{formdata_valid_error.endTime.errormsg}</div> : ''}
                </div>
          
                <div class="form-intem">
                    <label htmlFor="titles">{t("Title")}{formdata_valid_error.title.required? <span>*</span> : ''}</label>
                    <input type="text" onChange={handleChange}  name="title" id="titles" placeholder={t('Enter_title')} />
                    {formdata_valid_error.title.error? <div className="error">{formdata_valid_error.title.errormsg}</div> : ''}
                </div>
                     <div class="form-intem">
                    <label htmlFor="costs">{t("Cost")}{formdata_valid_error.cost.required? <span>*</span> : ''}</label>
                    <input type="text" onChange={handleChange}  name="cost" id="costs" placeholder={t('Enter_your_cost')} />
                 {formdata_valid_error.cost.error? <div className="error">{formdata_valid_error.cost.errormsg}</div> : ''}

                </div>
                <div class="form-intem">
                    <label htmlFor="country">{t("select_country")}</label>
                    <select name="countryId" onChange={handleChange}  id="countryId">
                        {country_detils.map((description, index) => (
                            <option
                              key={index}
                              value={description.value}
                            >
                              {description.label}
                            </option>
                          ))}
                    </select>
                     
                </div>
                <div class="form-intem">
                    <label htmlFor="addrs">{t("Address")}{formdata_valid_error.address.required? <span>*</span> : ''}</label>
                    <textarea name="address" onChange={handleChange} ></textarea>
                    {formdata_valid_error.address.error? <div className="error">{formdata_valid_error.address.errormsg}</div> : ''} 
                </div>
                    <div class="form-intem">
                    <label htmlFor="titles">{t("campaignCode")}{formdata_valid_error.campaignCode.required? <span>*</span> : ''}</label>
                    <input type="text" onChange={handleChange}  name="campaignCode" id="campaignCode" placeholder={t("Enter_campaignCode")} />
                    {formdata_valid_error.campaignCode.error? <div className="error">{formdata_valid_error.campaignCode.errormsg}</div> : ''}
                </div>
           
                <div class="form-intem form-item-full">
                    <button type="submit">{t("Submit")}</button>
                </div>
            </div>
        </form> : <div className="form-submit-success">
                              {t('New_session_created_successfully')}
                            </div>  }
    </div>
</section>
  );
};

export default Body;